import React from 'react';
import { Icon } from '../Actions.styles';
import { ViewContainer } from './CommentsAction.styles';
import { useTheme } from '../../../../../../context/PermissionsContext/ThemeContext/ThemeContext';
interface Props {
  totalComment: number;
  onNavigateToComments: () => void;
}

const CommentsActionView = ({ totalComment, onNavigateToComments }: Props) => {
  const { theme } = useTheme();
  return (
    <ViewContainer onClick={onNavigateToComments}>
      <Icon
        src={`/images/comment-${totalComment ? 'filled' : 'outline'}${
          theme.isDark ? '-white' : ''
        }.svg`}
      />
      <div style={{ fontWeight: 600, fontSize: 12 }}>
        {totalComment || null}
      </div>
    </ViewContainer>
  );
};

export default CommentsActionView;
